export default {
    props: ['studyId'],
    data(){
        return {
            id:'',
            url:'',
        }
    },
    methods:{
        getResourse(){
            this.$post('resources/get',{id:this.id,token:this.$store.state.id}).then(res=>{
                this.url= this.imgUrl+res.data.result.data;
                // console.log(this.url)
            });
        }
    },
    created(){
        this.id= this.studyId;
    },
    mounted(){
        this.getResourse();
    }
}